//import libs
import React, { useRef } from 'react';
//import components
import ImplementationProcess from './implementationProcess';
import Carefree from './carefree';
import ExtensiveCoverage from './extensiveCoverage';
import ReportDamage from './reportDamage';
import FrequentlyAskedQuestions from './frequentlyAskedQuestions';
import Banner from '@modules/app/components/banner/banner.js';
import Header from '@modules/app/components/header/header.js';
import Footer from '@modules/app/components/footer/footer.js';
function Home() {
  const implementationProcessRef = useRef();
  const extensiveCoverageRef = useRef();
  const frequentlyAskedQuestionsRef = useRef();
  function handleScrollClick(item) {
    switch (item) {
      case 'implementationProcessRef':
        implementationProcessRef.current.scrollIntoView({ behavior: 'smooth' });
        break;
      case 'extensiveCoverageRef':
        extensiveCoverageRef.current.scrollIntoView({ behavior: 'smooth' });
        break;
      case 'frequentlyAskedQuestionsRef':
        frequentlyAskedQuestionsRef.current.scrollIntoView({ behavior: 'smooth' });
        break;
      default:
        break;
    }
  }
  return (
    <div>
      <Header handleScrollClick={handleScrollClick} />
      <Banner />
      <ImplementationProcess implementationProcessRef={implementationProcessRef} />
      <Carefree />
      <ExtensiveCoverage extensiveCoverageRef={extensiveCoverageRef} />
      <ReportDamage />
      <FrequentlyAskedQuestions frequentlyAskedQuestionsRef={frequentlyAskedQuestionsRef} />
      <Footer />
    </div>
  );
}

export default Home;
